// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import './fonts.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';
// import { Provider } from 'react-redux';
// import { createStore, applyMiddleware, compose } from 'redux';
// import reducers from './reducers';
// import thunk from 'redux-thunk';

// import './fonts/Kanit-Light.ttf'
// import './fonts/Kanit-Regular.ttf'
// import './fonts/Kanit-Italic.ttf'
// import './fonts/Kanit-Medium.ttf'
// import './fonts/Kanit-Medium.ttf'

// ReactDOM.render(
//   <Provider store={createStore(reducers, compose(
//     applyMiddleware(thunk),
//     window.devToolsExtension ? window.devToolsExtension() : f => f
//   ))}>
//     <App />
//   </Provider>,
//   document.getElementById('root')
// );


// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './fonts.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';

import './fonts/Kanit-Light.ttf';
import './fonts/Kanit-Regular.ttf';
import './fonts/Kanit-Italic.ttf';
import './fonts/Kanit-Medium.ttf';

// --- Create store ONCE ---
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk))
);

// --- Render App with store ---
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// Service Worker (keep it as unregister unless you want PWA caching)
serviceWorker.unregister();
